import React, {CSSProperties, FunctionComponent} from "react";
import {Box, Button, makeStyles, Theme} from "@material-ui/core";
import {withTheme} from "@material-ui/styles";
import Text from "./Text";
import checkboxChecked from "../images/Button/checkbox-checked.svg";
import checkboxUnchecked from "../images/Button/checkbox-unchecked.svg";

interface CheckButtonOuterProps {
    isChecked?: boolean;
    text?: string;
    onClick: () => void;
    width?: number;
    style?: CSSProperties;
    disabled?: boolean;
}

interface CheckButtonInnerProps {
    theme: Theme & any;
}

type CheckButtonProps = CheckButtonInnerProps & CheckButtonOuterProps;

const useStyles = makeStyles(theme => ({
    button: {
        borderRadius: theme.shape.borderRadius,
        padding: 0,
        minWidth: 0
    }
}));

const GradientButton: FunctionComponent<CheckButtonProps> = ({width, onClick, text, isChecked, style, disabled}) => {
    const classes = useStyles();
    return (
        <Button className={classes.button} style={{...style, width}} onClick={onClick} disabled={disabled}>
            <img src={isChecked ? checkboxChecked : checkboxUnchecked} alt={"checkbox"} style={{width, filter: disabled ? "grayscale(1)" : undefined}}/>
            <Box style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width : "100%"
            }}>
                <Text color={disabled ? "grey" : undefined} value={String(text)} size={13}/>
            </Box>
        </Button>
    );
};

export default withTheme(GradientButton);
